// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title{padding:12px 0;padding-left:15px;font-size:24px;font-weight:700;line-height:32px;position:relative;color:#409eff}.title:after{content:\"\";width:5px;height:24px;background:#409eff;position:absolute;top:50%;left:0;transform:translateY(-50%)}", ""]);
// Exports
module.exports = exports;
